
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Privacy from '../pages/privacy/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
